export default class LicenseManagement {
  // 获取部门
  static getDeptList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/sysDept/list', 'post', data, axiosOption, httpOption);
  }
  static getPeopleList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/sysUser/list', 'post', data, axiosOption, httpOption);
  }
  
  static getList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/listByDatasourceId/oaFormStaffLicensertext', 'post', data, axiosOption, httpOption);
  }
  static createdLicense (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/addDatasource/oaFormStaffLicensertext', 'post', data, axiosOption, httpOption);
  }
  static updateLicenser (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/updateDatasource/oaFormStaffLicensertext', 'post', data, axiosOption, httpOption);
  }
  
  static deleteoaFormStaffLicenser (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/deleteDatasource/oaFormStaffLicensertext', 'post', data, axiosOption, httpOption);
  }
  static deleteoaFormStaffLicenserList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/deleteBatchDatasource/oaFormStaffLicensertext', 'post', data, axiosOption, httpOption);
  }
  // 项目证照查询  
  static getProjectLicense (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaProject/license/list', 'post', data, axiosOption, httpOption);
  }
}
